import React, { useContext } from 'react';
import { BaseCloseButton, RegularButton } from '../button';
import { SnackViewContext } from './snack-view';
const variantToInvertMap = {
  primary: true,
  alert: false,
  error: true,
  neutral: false,
  success: true
};
/**
 * Компонент <SnackCloseButton /> -  -  представление кнопки закрыть, специально стилизованной для компонента `<Snack />`.
 */
export const SnackCloseButton = props => {
  const {
    variant
  } = useContext(SnackViewContext);
  return /*#__PURE__*/React.createElement(BaseCloseButton, {
    invert: variantToInvertMap[variant || 'neutral'],
    ...props
  });
};
/**
 * Компонент `<SnackButton />` -  представление кнопки, специально стилизованной для компонента `<Snack />`.
 */
export const SnackButton = ({
  ...props
}) => {
  const snakViewInvert = useContext(SnackViewContext).variant;
  return /*#__PURE__*/React.createElement(RegularButton, {
    size: "s",
    variant: "pseudo",
    invert: variantToInvertMap[snakViewInvert || 'neutral'],
    ...props
  });
};